import { useState, useEffect } from 'react'
import { Card, Spin, Empty, Tag } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'
import { getStockGovernance } from '@/api/stock'
import type { StockExecutive } from '@/types/stockPool'

function ComingSoon({ title, desc }: { title: string; desc?: string }) {
    return (
        <div className="coming-soon">
            <div className="coming-soon-icon">
                <ClockCircleOutlined style={{ fontSize: 28, color: '#d9d9d9' }} />
            </div>
            <div className="coming-soon-title">{title}</div>
            <div className="coming-soon-desc">{desc ?? '该功能正在建设中，接口就绪后即可上线'}</div>
        </div>
    )
}

function fmtSalary(val: number | null, currency: string | null): string {
    if (val == null) return '--'
    const unit = val >= 1e6 ? `${(val / 1e6).toFixed(1)}M` : val >= 1e4 ? `${(val / 1e4).toFixed(0)}万` : String(val)
    return currency ? `${currency} ${unit}` : unit
}

interface Props {
    stockCode: string
}

export default function CompanyTab({ stockCode }: Props) {
    const [executives, setExecutives] = useState<StockExecutive[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (!stockCode) return
        setExecutives([])
        setLoading(true)
        getStockGovernance(stockCode)
            .then(data => setExecutives(data?.executives ?? []))
            .catch(() => setExecutives([]))
            .finally(() => setLoading(false))
    }, [stockCode])

    return (
        <div className="new-kb-tab company-tab">
            <Card title="管理层" size="small" className="new-kb-card">
                {loading ? (
                    <div className="chart-placeholder" style={{ height: 100 }}><Spin /></div>
                ) : executives.length === 0 ? (
                    <Empty description="暂无管理层数据" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ padding: '16px 0' }} />
                ) : (
                    <div className="fin-table-wrap">
                        <table className="fin-table">
                            <thead>
                                <tr>
                                    <th>姓名</th>
                                    <th>职位</th>
                                    <th>性别</th>
                                    <th>年龄</th>
                                    <th>学历</th>
                                    <th>任职日期</th>
                                    <th>年薪</th>
                                </tr>
                            </thead>
                            <tbody>
                                {executives.map((e, i) => (
                                    <tr key={i}>
                                        <td className="fin-table-label">
                                            {e.display_leader_name || e.leader_name}
                                        </td>
                                        <td style={{ textAlign: 'left' }}>
                                            <Tag style={{ fontSize: 11, margin: 0 }}>{e.position_name}</Tag>
                                        </td>
                                        <td>{e.leader_gender ?? '--'}</td>
                                        <td>{e.leader_age ?? '--'}</td>
                                        <td>{e.highest_education ?? '--'}</td>
                                        <td>{e.begin_date?.slice(0, 10) ?? '--'}</td>
                                        <td>{fmtSalary(e.annual_salary, e.annual_salary_currency)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </Card>

            <Card title="业绩日历" size="small" className="new-kb-card">
                <ComingSoon title="业绩日历即将上线" desc="接口就绪后展示下次财报日期及历史 EPS 超预期记录" />
            </Card>

            <Card title="同行比较" size="small" className="new-kb-card">
                <ComingSoon title="同行比较即将上线" desc="将展示同板块可比公司的市值、PE、YTD 涨幅等核心指标" />
            </Card>
        </div>
    )
}
